import CountdownTimer from "@unisearch/common/countdown_timer";
import Link from "next/link";
import { FiClock } from "react-icons/fi";
import { MdCalendarToday, MdLocationPin } from "react-icons/md";
import styles from "./upcoming_event.module.scss";
import { useGetEventsQuery } from "@redux/event/eventApi";
import { excerpt, htmlParse } from "@unisearch/helpers";
import moment from "moment";
import Skeleton from "@unisearch/common/skeleton";

export const UpcomingEvent = () => {
  const { data, isLoading, isError, error } = useGetEventsQuery();
  const dataEvent = data?.data;

  console.log("data", dataEvent);

  return (
    <section>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.heading_wrapper}>
            <h2 className="m-0 pb-4">Upcoming Events</h2>
          </div>

          {isLoading ? (
            <div className="grid lg:grid-cols-3 gap-7">
              {new Array(3).fill(1).map((_, i) => {
                return (
                  <div key={i}>
                    <Skeleton height={230} className="mb-2" />
                    <Skeleton height={40} className="mb-2" />
                    <Skeleton height={40} />
                  </div>
                );
              })}
            </div>
          ) : (
            <div>
              {dataEvent && dataEvent?.length > 0 ? (
                <div className="grid lg:grid-cols-3 gap-5 lg:gap-7">
                  {dataEvent?.map((item, i) => {
                    return (
                      <Link href={`/events/${item?.slug}`} key={i}>
                        <div className={styles.card}>
                          <div className={`${styles.card_head}`}>
                            <img
                              src={
                                item?.heroimage?.src ||
                                "/assets/images/image_placeholder_big.webp"
                              }
                              alt={item?.eventTitle}
                            />
                            <div className={styles.card_overlay_wrapper}>
                              {item?.eventDate && (
                                <div className={styles.card_time_wrapper}>
                                  <CountdownTimer
                                    targetDate={item?.eventDate}
                                  />
                                </div>
                              )}

                              {item?.eventDate && (
                                <div
                                  className={`${styles.card_date_wrapper} justify-center text-center`}
                                >
                                  <div className={styles.card_date}>
                                    <MdCalendarToday />
                                    {/* <span>March 24, 2024</span> */}
                                    <span>
                                      {moment(item?.eventDate).format("LL")}
                                    </span>
                                  </div>
                                  {/* <div className={styles.card_date}>
                              <FiClock />
                              <span>2:30 PM</span>
                            </div> */}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className={styles.card_body}>
                            {item?.eventTitle && (
                              <h4 className={styles.card_title}>
                                {item?.eventTitle}
                              </h4>
                            )}

                            {item?.address && (
                              <div className={`flex gap-1`}>
                                <MdLocationPin className="shrink-0 mt-[2px]" />
                                <div className="inline-flex text-sm line-clamp-2">
                                  {excerpt(item?.address)}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              ) : (
                <div className="flex items-center justify-center p-10 text-[30px] font-medium">
                  No event found!
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default UpcomingEvent;
